export const initialState = () => ({
	items: [],
	skeleton: {
		fullname: '',
		email: '',
		phone: '',
		company: '',
		message: ''
	},
	validation: {
		fullname: {
			min:3,
			max:50
		},
		message: {
			min:10,
			max:1000
		}
	}	
});

export default initialState();
